import React, { useEffect, useState } from "react";
import content from "main/helpers/contentHelper.json";
import contactusbanner1 from "../../../main/assets/images/Images/Strategic Planning-Images/strategic-planning-banner.png";
import { MainPageHeader } from "main/components";

type Props = {};

const PrivacyPolicy = (props: Props) => {
  const [data, setData] = useState<any>(undefined);
  useEffect(() => {
    window.scrollTo(0, 0);
    setData(content);
  }, []);

  return (
    <>
      <div className="Privacy_Policy">
        <MainPageHeader
          mobilebgImage={contactusbanner1}
          backgroundImage={contactusbanner1}
          heading={"Privacy Policy"}
          description={"This policy was updated on 22 May 2025"}
          descriptionClass="text-white-color font-family-roboto w-100"
        />
        <div className="container d-flex col-12 section2 gap-20 py-60">
          <div className="row">
            <div className="col-12 col-lg-12">
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                Scope of Application
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-24 footer-subcontent">
                This Privacy Notice applies to processing of personal data that
                is collected, which means information about an identifiable
                individual (“you”), that Yantr (“Company”, “Yantr.ai”, “we” or
                “us”) collect through our website (“Tool” or “website”) about
                you as a visitor of the website, applicants or freelancers,
                (collectively “Applicants”). It also describes your data
                protection rights, including your right to object to some of the
                processing that Yantr.ai may carry out. More information about
                your rights and how to exercise them is set out in the Your
                Choices and Rights section below.
              </p>
              <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-40 line-24 footer-subcontent">
                For current or former employees, applicants, contractors,
                subcontractors, and employees of contractors or subcontractors
                (collectively referred to as "workers") dependents and
                beneficiaries, applicable privacy notice is the Worker Privacy
                Notice.
              </p>
              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-contentg">
                What Personal Data we may collect from website users:
              </p>
              <div className="pl-60 col-md-12 d-flex align-item-center align-self-center pb-20">
                <ul className="mb-0">
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2"
                  >
                    <span className="text-black-90 font-family-roboto font-18 fonts-600 pb-20 line-26 aboutus-subcontent">
                      Personal Information and communication information:&nbsp;
                    </span>{" "}
                    Name, Address, Phone number, Email address, Job title,
                    company, your request details.
                  </li>
                </ul>
              </div>

              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                What Personal Data we may collect from Applicants:
              </p>
              <p className="dark-header font-28 fonts-400 pb-20 line-32 font-family-roboto contactus-heading">
                Personal Identification and communication information:
              </p>

              <div className="pl-60 col-md-12 d-flex align-item-center align-self-center pb-20">
                <ul className="mb-0">
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2"
                  >
                    <span className="text-black-90 font-family-roboto font-18 fonts-600 pb-20 line-26 aboutus-subcontent">
                      Personal Information:&nbsp;
                    </span>{" "}
                    Name, Home Address, Phone number, Email address, Photo,
                    Employee ID number.
                  </li>
                </ul>
              </div>

              <p className="text-primary1 font-30 fonts-800 pb-20 line-35 font-family-roboto footer-content">
                Why we collect, Use and Store the Personal Data
              </p>
              <div className="pl-60 col-md-12">
                <ul className="mb-0">
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent"
                  >
                    Collection of personal information for propagating business:
                  </li>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    From time to time, we may request aforementioned Personal
                    Information from you to process your job applications
                    through our website and/or to get valuable feedback from
                    your experience on our website. In addition, we may also use
                    your personal information for other business purposes or in
                    order to help serve you better, such as informing you of new
                    services, products or alliances that could help you in your
                    career or business. Your posting of any such Personal
                    Information is entirely your discretion. While you can visit
                    our site without disclosing any Personal Information,
                    however, to apply or to register on our website there are
                    web pages that require such information to complete certain
                    functions, thus these web pages may not be available to you
                    if you decide not to reveal the information requested. We
                    will take reasonable steps to ensure that your Personal
                    Information is accurate and complete.
                  </p>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    Third parties such as employers, companies across the globe
                    may access your Personal Information to verify your details
                    and offer you appropriate employment or work through the
                    website.
                  </p>
                </ul>
              </div>
              <div className="pl-60 col-md-12">
                <ul>
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent"
                  >
                    Collecting information for on-line surveys:
                  </li>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    At times, we conduct online surveys to better understand the
                    needs and profile of our visitors. When we conduct a survey,
                    we will inform you about how we will use the information
                    prior to your taking the survey. If you do not want to
                    participate in the survey, you may refrain from contributing
                    to it at your own discretion. We may share survey
                    participation requests based on our legitimate interest to
                    improve our services, under specific circumstances, or if
                    you have consented to it.
                  </p>
                </ul>
              </div>
              <div className="pl-60 col-md-12">
                <ul>
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent"
                  >
                    Collecting domain information
                  </li>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    Our Website may use a technology known as web beacons -
                    sometimes called single-pixel gifs - that allow this site to
                    collect web log information. A web beacon is a graphic on a
                    web page or in an email message designed to track pages
                    viewed or messages opened. Web log information is gathered
                    when you visit one of our Websites by the computer that
                    hosts our Website (called a “webserver”). The webserver
                    automatically recognizes some information, such as the date
                    and time you visited our site, the pages you visited, the
                    website you came from (to the extent you have given your
                    consent), the type of browser you are using (e.g., Internet
                    Explorer), the type of operating system you are using (e.g.,
                    Windows 10) and the domain name and address of your Internet
                    service provider. If you have given your consent, we may
                    also include web beacons in promotional email messages in
                    order to determine whether messages have been opened.
                  </p>
                </ul>
              </div>
              <div className="pl-60 col-md-12">
                <ul>
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent"
                  >
                    Use of cookies
                  </li>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    To the extent you have given your consent, our Website uses
                    a technology called a “cookie”. A cookie is a piece of
                    information that our webserver sends to your computer
                    (actually to your browser file) when you access a website.
                    Then when you come back our site will detect whether you
                    have one of our cookies on your computer. Our cookies help
                    provide additional functionality to the site and help us
                    analyze site usage more accurately. For instance, our site
                    may set a cookie on your browser that keeps you from needing
                    to remember and then enter a password more than once during
                    a visit to the site.
                  </p>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    Cookies are categorized based on the functionality. You can
                    opt-out of each cookie category (except strictly necessary
                    cookies) by clicking on the specific checkbox of the
                    category under “Cookies Settings” option on cookie banner.{" "}
                  </p>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    If you would like to change your cookie preferences, please
                    click here For further information on cookies and cookie
                    banner please refer:
                    <a href=" https://www.techmahindra.com/cookie-policy/">
                      {" "}
                      https://www.techmahindra.com/cookie-policy/
                    </a>
                  </p>
                </ul>
              </div>
              <div className="pl-60 col-md-12">
                <ul>
                  <li
                    style={{ listStyleType: "disc" }}
                    className="text-black-90 font-family-roboto font-20 fonts-800 pb-10 line-26 aboutus-subcontent"
                  >
                    IP address
                  </li>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                    Our Website uses Internet Protocol (IP) Addresses. An IP
                    Address is a number assigned to your computer by your
                    Internet service provider, so you can access the Internet.
                    Generally, an IP address changes each time you connect to
                    the Internet (it is a “dynamic” address). We use your IP
                    address to report aggregate information on use and to help
                    improve the Website.
                  </p>
                  <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-40 line-26 footer-subcontent2">
                    Areas of this Website that collect your Information use
                    industry standard secure socket layer encryption (SSL),
                    reasonable security controls, appropriate technical,
                    physical organizational security controls are employed for
                    protection of data; however, to take advantage of this your
                    browser must support encryption protection (found in Chrome,
                    Internet Explorer release 3.0 and above).
                  </p>
                </ul>
              </div>
              <p className="text-primary1 font-family-roboto font-30 fonts-800 pb-20 line-35 footer-content">
                Processing purposes
              </p>
              <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                We process the data to ensure a proper connection buildup,
                system security and to improve our website. We process your
                Personal Information when it is necessary for the purposes of a
                legitimate interest pursued by us (when these interests are not
                overridden by your data protection rights) under the
                circumstances like mentioned below.
              </p>
              <ul className="pl-60">
                <li
                  style={{ listStyleType: "disc" }}
                  className="fonts-400 font-18 font-family-roboto text-black-90 pb-10 line-24 footer-subcontent"
                >
                  To identify you once you register on our website; and
                </li>
                <li
                  style={{ listStyleType: "disc" }}
                  className="fonts-400 font-18 font-family-roboto text-black-90 pb-10 line-24 footer-subcontent"
                >
                  To contact you and respond to your questions or requests;
                </li>
                <li
                  style={{ listStyleType: "disc" }}
                  className="fonts-400 font-18 font-family-roboto text-black-90 pb-10 line-24 footer-subcontent"
                >
                  To understand which parts of the website are visited and how
                  frequently; and to provide access to desirable content based
                  on your preferences.
                </li>
              </ul>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  Disclosure to third parties
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                  To the extent permitted by law and to fulfil the purpose of
                  this website, we may share your Personal Information with
                  agents, contractors or partners of the Company in connection
                  with the services that these individuals or entities perform
                  for or with the Company. These agents, contractors or partners
                  are restricted from using this data in any way other than to
                  provide services for the Company or services for the
                  collaboration in which they and the Company are engaged in
                  (for example, some of our products are developed and marketed
                  through joint agreements with other companies). We may, for
                  example, provide your information to agents, contractors or
                  partners for hosting our databases, for data processing
                  services or so that they can mail you information that you
                  requested for. You may remove yourself from any such list or
                  notification at any time.
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                  The Company reserves the right to share your Personal
                  Information to respond to duly authorized information requests
                  of governmental authorities or where required by law. In
                  exceptionally rare circumstances where national, state or
                  company security is at issue. The Company reserves the right
                  to share our entire database of visitors and customers with
                  appropriate governmental authorities.{" "}
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                  We may also be required to disclose your Personal Information
                  in the event of a legal investigation or any such other
                  process where we are required to do so by applicable law or
                  where we have to establish our legal rights or where
                  disclosure is required to prevent or take action regarding
                  illegal activities, suspected fraud or situations involving
                  potential threats to the physical safety of any person.{" "}
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                  To the extent permitted by law, we may also provide your
                  Information to a third party in connection with the sale,
                  assignment or other transfer of the business of this Website
                  to which the information relates, in which case we will
                  require any such buyer to agree to treat your Personal
                  Information in accordance with this Privacy Policy.{" "}
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-24 footer-subcontent">
                  As a convenience to our visitors, this Website may contain
                  links to a number of sites that we believe may offer useful
                  information. The policies and procedures we described here may
                  not apply to those sites. We suggest contacting those sites
                  directly for information on their privacy, security, data
                  collection and distribution policies.
                </p>
              </div>

              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  Verification of Data
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  To the extent permitted by law, it will be necessary for us to
                  verify the details you have supplied (e.g. your identity,
                  employment history, academic qualification and professional
                  credentials). Such verification could be done through third
                  party service providers, who shall be bound to obligation of
                  confidentiality and data protection.
                </p>
              </div>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  Re-captcha
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  To protect our web forms from automated requests, we use a
                  so-called captcha from a third-party provider (Google). Within
                  the scope of the captcha function, you may be asked to solve
                  tasks or click on checkboxes. The user input made in this
                  context and possibly also the mouse movements are used to
                  assess whether the input originates from a human or an
                  automated program.
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  Since the function is provided by a third-party provider, the
                  display of the captcha leads to content from the third-party
                  provider being reloaded. The third-party provider is therefore
                  able to obtain the information that you have accessed our site
                  as well as the usage data that is technically required in this
                  context. We have no influence on the further data processing
                  by the third-party provider.{" "}
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  The embedding is based on our legitimate interest of
                  protection against spam and abuse. If data is processed
                  outside the EU or the EEA (in particular in the USA) in this
                  context, we provide information about the level of data
                  protection in the following table. For transfers to the U.S.,
                  an adequate level of data protection is ensured due to the
                  certification of the provider under the adequacy decision
                  (EU-U.S. Data Privacy Framework).{" "}
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  If you wish to object to data processing, please do not use
                  our web forms, but contact us by another means.{" "}
                </p>
              </div>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  Monitoring
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  Where permitted by applicable law, Yantr.ai reserves the right
                  to monitor, intercept, access and erase all information,
                  material, data and communication (including emails, telephonic
                  conversations and voicemail recordings) regarding registration
                  and further processing of your application through the website
                  or Tool.
                </p>
              </div>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  How we share your personal data
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  We will share your personal data with other Tech Mahindra
                  Group or third-party companies, to the extent required for the
                  work or work opportunity, you are applying for employment or
                  assignments.
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  In the event that a Yantr.ai business is sold or integrate
                  with another business in total or in part, your details may be
                  disclosed to our advisers and prospective purchaser’s advisers
                  and will be passed on to the new owners of the business.{" "}
                </p>
                {/* <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  In the event that a Yantr.ai business is sold or integrate
                  with another business in total or in part, your details may be
                  disclosed to our advisers and prospective purchaser’s advisers
                  and will be passed on to the new owners of the business.
                </p> */}
              </div>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  Your Choices and Rights
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  You have the right to ask Yantr.ai for copy of your personal
                  data; to correct, delete or restrict processing of your
                  persona data; and to obtain the personal data you provide in a
                  structured and machine-readable format. In addition, you can
                  object to the processing of personal data, in some
                  circumstances (in particular, where we do not have to process
                  the data to meet a contractual or legal requirement). Where we
                  have asked for your consent, you may withdraw consent at any
                  time. If you have asked to withdraw your consent to Yantr.ai
                  from processing your data, this will not affect any processing
                  which has already taken place at that time. For any such
                  queries you may contact{" "}
                  <a href="yantrai.coreteam@techmahindra.com">
                    yantrai.coreteam@techmahindra.com
                  </a>
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  These rights may be limited, for example, if fulfilling your
                  request would reveal personal data of another person or if you
                  ask us to delete information which we are required by law or
                  have compelling legitimate interests to keep. If you have
                  unresolved concerns, you have the right to complain to the
                  data protection authority.{" "}
                </p>
              </div>
              <div className="col-md-12">
                <p className="text-primary1 font-family-roboto font-30 fonts-800 py-20 line-35 footer-content">
                  How long do we retain your personal data
                </p>
                <p className="text-black-90 font-family-roboto font-18 fonts-400 pb-20 line-26 footer-subcontent2">
                  We will retain your personal data only for as long as we need
                  it for Yantr.ai’s legitimate business interest in accordance
                  with applicable laws, to fulfil your registration and
                  application process and to perform services as you have opted
                  for or to meet legal requirements, after which we will take
                  steps to delete your personal data or hold it in a form that
                  no longer identifies you.
                </p>
              </div>
              <div className="col-md-12">
                <p className="dark-header font-28 fonts-400 py-20 line-32 font-family-roboto contactus-heading">
                  Updates to this Privacy Notice
                </p>
                <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-26 footer-subcontent">
                  This Privacy Policy may be updated periodically. We will
                  encourage you to check for changes to this Privacy Policy
                  occasionally, which will be available at :&nbsp;
                  <a href="/privacy-policy">Privacy Policy</a>
                </p>
                <p className="fonts-400 font-18 font-family-roboto text-black-90 pb-20 line-26 footer-subcontent">
                  On some occasions, we may also actively advise you of specific
                  data handling activities or significant changes to this
                  Privacy Policy, as required by the applicable law.
                </p>
                <p className="dark-header font-28 fonts-400 py-20 line-32 font-family-roboto contactus-heading">
                  Contact Us
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-26 footer-subcontent">
                  The Data Controller for your personal data will be Yantr.ai
                  through whom you are registering or applying for relevant work
                  or employment positions.
                </p>
                <p className="fonts-400 font-family-roboto font-18 text-black-90 pb-20 line-26 footer-subcontent">
                  If you have any question about this Privacy Policy or wish to
                  contact us for any reason in relation to our personal data
                  processing, please contact us at:&nbsp;
                  <a href="mailto:yantrai.coreteam@techmahindra.com">
                    yantrai.coreteam@techmahindra.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
